import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'
import Api from 'fou-api'
import isEqual from 'lodash/isEqual'

export default {
  namespaced: true,

  state () {
    return {
      allFamilies: [],
      taggedFamilies: [],
      taggedErrorFamilies: [],
      queries: {
        sortBy: 'startDate',
        sortDirection: 'desc',
        perPage: 20
      },
      promotions: [],
      count: 0,
      uploading: false,
      uploadingAllFamilies: false,
      uploadingTaggedFamilies: false,
      creatingPromotion: false,
      updatingPromotion: false,
      familyQuery: {
        name: null,
        page: null,
        perPage: null,
        uniqueName: null
      },
      isSuccess: false,
      allPromotions: 0,
      operationType: null
    }
  },

  getters: {
    familiesList: state => {
      return state.allFamilies
    },
    taggedFamiliesList: state => {
      return state.taggedFamilies
    },
    taggedErrorFamiliesList: state => {
      return state.taggedErrorFamilies
    },
    promotionsList: state => {
      return state.promotions
    },
    promotionsCount: state => {
      return state.count
    },
    queries: state => {
      return state.queries
    },
    uploading: state => {
      return state.uploading
    },
    uploadingAllFamilies: state => {
      return state.uploadingAllFamilies
    },
    uploadingTaggedFamilies: state => {
      return state.uploadingTaggedFamilies
    },
    creatingPromotion: state => {
      return state.creatingPromotion
    },
    updatingPromotion: state => {
      return state.updatingPromotion
    },
    isSuccessFull: state => {
      return state.isSuccess
    },
    getPromotionsLenght: state => {
      return state.allPromotions
    },
    getOperationType: state => {
      return state.operationType
    }
  },

  mutations: {
    addAllFamilies (state, allFamilies) {
      state.allFamilies = allFamilies
    },
    clearAllFamilies (state) {
      state.allFamilies = []
    },
    uploadAllFamiliesStart (state) {
      state.uploadingAllFamilies = true
    },
    uploadAllFamiliesComplete (state) {
      state.uploadingAllFamilies = false
    },
    addTaggedFamilies (state, taggedFamilies) {
      if (state.taggedFamilies.length > 0) {
        const oldTaggedFamiliesIds = state.taggedFamilies.map((data) => data.id) // old tagged families Id list in vuex store
        const newResTaggedFamiliesIds = taggedFamilies.map(data => data.id) // new response tagged families Id list
        const oldUpdatedTaggedFamilies = state.taggedFamilies.filter(data => newResTaggedFamiliesIds.includes(data.id)) // old tagged families updated when user dislect the fonts from dropdown
        const newTaggedFamily = taggedFamilies.filter((data) => !oldTaggedFamiliesIds.includes(data.id)) // Newly Tagged Family
        if (isEqual(newTaggedFamily.length, 0)) {
          state.taggedFamilies = [...oldUpdatedTaggedFamilies];
        } else if (isEqual(oldUpdatedTaggedFamilies.length, 0)) {
          state.taggedFamilies = [...newTaggedFamily];
        } else {
          state.taggedFamilies = [...oldUpdatedTaggedFamilies, ...newTaggedFamily];
        }
      } else {
        state.taggedFamilies = taggedFamilies
      }
    },
    addTaggedErrorFamilies (state, taggedErrorFamilies) {
      state.taggedErrorFamilies = taggedErrorFamilies
    },
    addCheckedPacksInTaggedFamilies (state, checkedPacksData) {
      state.taggedFamilies = state.taggedFamilies.map((data) => {
        if (isEqual(data.id, checkedPacksData.selectedFamilyId)) {
          return ({
            ...data,
            checkedPacksArr: checkedPacksData.checkedPacksArr,
            isAllPacks: checkedPacksData.isAllPacks,
            isAllStyles: checkedPacksData.isAllStyles
          })
        }
        return data
      })
    },
    updateTaggedFamilies (state, id) {
      state.taggedFamilies = state.taggedFamilies.filter(val => val.id !== id)
    },
    updateTaggedErrorFamilies (state, familyIdToBeRemoved) {
      state.taggedErrorFamilies = state.taggedErrorFamilies.filter((data) => data.errorInfo.familyId !== familyIdToBeRemoved)
    },
    clearTaggedFamilies (state) {
      state.taggedFamilies = []
    },
    clearTaggedErrorFamilies (state) {
      state.taggedErrorFamilies = []
    },
    uploadTaggedFamiliesStart (state) {
      state.uploadingTaggedFamilies = true
    },
    uploadTaggedFamiliesComplete (state) {
      state.uploadingTaggedFamilies = false
    },
    setAll (state, { list = [], options }) {
      if (options.page === 1) {
        state.promotions = [...list]
      } else {
        state.promotions = [...state.promotions, ...list]
      }
    },
    setCount (state, count) {
      state.count = count
    },
    emptyPromotions (state) {
      state.promotions = []
      state.count = 0
    },
    uploadStart (state) {
      state.uploading = true
    },
    uploadComplete (state) {
      state.uploading = false
    },
    createPromoStart (state) {
      state.creatingPromotion = true
    },
    createPromoComplete (state) {
      state.creatingPromotion = false
    },
    updatePromoStart (state) {
      state.updatingPromotion = true
    },
    updatePromoComplete (state) {
      state.updatingPromotion = false
    },
    setIsSuccess (state) {
      state.isSuccess = true
    },
    unsetIsSuccess (state) {
      state.isSuccess = false
    },
    setPrmotionlenght(state,count) {
      state.allPromotions = count
    },
    clearPromotionsLength (state) {
      state.allPromotions = 0
    },
    setOperationType(state, operationType) {
      state.operationType = operationType;
    }
  },

  actions: {
    getAllFamilies ({ commit, state }, options = { id: null, name: null }) {
      if (!isEqual(state.taggedFamilies.length, 0)) { commit('clearTaggedFamilies') }
      commit('clearAllFamilies')
      commit('uploadAllFamiliesStart')
      return new Promise((resolve, reject) => {
        Api.Families.getFamilies(
          state.familyQuery.name || options.name,
          options.id
        ).then(response => {
          commit('addAllFamilies', response.data.families)
          commit('uploadAllFamiliesComplete')
          commit('uploadTaggedFamiliesComplete')
          resolve(response.data.families)
        }).catch(error => {
          const err = Errors.create(error)
          commit('errors/add', err)
          commit('uploadAllFamiliesComplete')
          reject(err)
        })
      })
    },
    getTaggedFamilies ({ commit, state }, options = { familyIds: [] }) {
      commit('uploadTaggedFamiliesStart')
      return new Promise((resolve, reject) => {
        Api.Families.getAllDetails(options)
          .then(response => {
            commit('addTaggedFamilies', response.data.collection)
            commit('addTaggedErrorFamilies', response.data.errors)
            commit('uploadTaggedFamiliesComplete')
            resolve(response.data.collection)
          }).catch(error => {
            const err = Errors.create(error)
            commit('errors/add', err)
            commit('uploadTaggedFamiliesComplete')
            reject(err)
          })
      })
    },
    getPromotions ({ commit, state }, options = {}) {
      const perPage = (options?.perPage) ?? state.queries.perPage
      const sortBy = (options?.sortBy) ?? state.queries.sortBy
      const sortDirection = (options?.sortDirection) ?? state.queries.sortDirection
      return new Promise((resolve, reject) => {
        Api.Promotions.getPromotions(
          options.promoTitle,
          'Y',
          options.status,
          (options.page * 1),
          (perPage * 1),
          sortBy,
          sortDirection
        )
          .then((response) => {
            const promotionlist = response.data.promotions.length
            commit('setPrmotionlenght', promotionlist)
            const list = response.data.promotions
            commit('setAll', { list, options })
            const count = response.data.count
            commit('setCount', count)
            resolve(response.data)
          })
          .catch((error) => {
            const err = Errors.create(error)
            commit('errors/add', err)
            reject(err)
          })
      })
    },
    getPromotionDetails ({ commit, state }, promotionId) {
      return new Promise((resolve, reject) => {
        Api.Promotions.getPromotion(promotionId)
          .then((response) => {
            commit('uploadComplete')
            resolve(response.data)
          })
          .catch((error) => {
            const err = Errors.create(error)
            commit('errors/add', err)
            reject(err)
          })
      })
    },
    createNewPromotion ({ commit, state }, options = {}) {
      commit('createPromoStart')
      return new Promise((resolve, reject) => {
        Api.Promotions.createPromotion({ ...options })
          .then(response => {
            commit('createPromoComplete')
            commit('setIsSuccess')
            commit('setOperationType','create')
            return resolve(response.data)
          })
          .catch((error) => {
            const err = Errors.create(error)
            commit('createPromoComplete')
            reject(err)
          })
      })
    },
    updatePromotion ({ commit, state }, options = {}) {
      commit('updatePromoStart')
      return new Promise((resolve, reject) => {
        Api.Promotions.updatePromotion(options.id, options)
          .then(response => {
            commit('clearTaggedFamilies')
            commit('updatePromoComplete')
            commit('setIsSuccess')
            if (options?.status == 'deleted') {
              commit('setOperationType', 'delete')
            } else {
              commit('setOperationType', 'create')
            }
            return resolve(response.data)
          })
          .catch((error) => {
            const err = Errors.create(error)
            commit('updatePromoComplete')
            return reject(err)
          })
      })
    },
    checkSecretCodeIsunique ({ commit, state }, secretCode) {
      return new Promise((resolve, reject) => {
        Api.SecretCode.checkUniqueSecretCode({ secretCode })
          .then((response) => resolve(response.data.isUnique))
          .catch((error) => {
            const err = Errors.create(error)
            commit('errors/add', err)
            reject(err)
          })
      })
    }
  },

  modules: {
    errors: VuexErrors
  }
}
